import firebase from "js/firebase";

const getStorage = options => options.bucket ? firebase.app().storage(options.bucket) : firebase.storage();

const FileStorage = {
    upload(options, metadata) {
        return new Promise((resolve, reject) => {
            const uploadTask = getStorage(options).ref(options.path).put(options.file, metadata);

            uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, snapshot => {
                var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                if (options.onProgress) {
                    options.onProgress(progress, snapshot.state);
                }
            }, error => {
                reject(error);
            }, () => {
                uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                    resolve({ downloadURL });
                });
            });
        });
    },
    delete(options) {
        return getStorage(options).ref(options.path).delete();
    },

    State: {
        PAUSED: firebase.storage.TaskState.PAUSED,
        RUNNING: firebase.storage.TaskState.RUNNING,
        SUCCESS: firebase.storage.TaskState.SUCCESS,
        CANCELED: firebase.storage.TaskState.CANCELED,
        ERROR: firebase.storage.TaskState.ERROR,
    }
};

export default FileStorage;
